$(document).ready(function() {
  // Handle variant selection change
  $('.product-variant.custom-1 select.product-variant-container').on('change', function() {
    var selectedValueName = $(this).find('option:selected').text().trim();

    // Remove 'activated' class from all options and add it to the selected one
    $(this).find('option').removeClass('activated');
    $(this).find('option:selected').addClass('activated');

    // Hide all descriptions
    $('.variant-description').hide();

    // Show the description matching the selected variant
    $('.variant-description').each(function() {
      var descriptionValueName = $(this).attr('value-name');
      if (descriptionValueName === selectedValueName) {
        $(this).show();
      }
    });
  });

  // Trigger the change event initially to load the default selected description
  $('.product-variant.custom-1 select.product-variant-container').trigger('change');
});
